import * as fetch from '../fetch'

export function remove_user_code_batch(data){
	return fetch.main_private_fetch({
		url: '/user/codedit/batch',
		method: 'delete',
		data,
	})
}
